import { ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsDrawer } from '../../../app/components/settings-drawer';
import type { LiquidityCalculatorSettingsSection } from '../../interfaces';
import { LiquidityCalculatorDateRangeSelect } from './liquidity-calculator-date-range-select';
import { LiquidityCashWithJbSettings } from './liquidity-cash-with-jb-settings';
import { LiquidityCashWithOtherBanksSettings } from './liquidity-cash-with-other-banks-settings';
import { LiquidityOneOffCashflowSettings } from './liquidity-one-off-cashflow-settings';
import { LiquidityRecurringCashflowSettings } from './liquidity-recurring-cashflow-settings';

interface ILiquidityCalculatorSettingsDrawerProps {
    isDrawerOpen: boolean;
    onCloseDrawer: () => void;
    expandedSection?: LiquidityCalculatorSettingsSection;
}

export const LiquidityCalculatorSettingsDrawer: FunctionComponent<ILiquidityCalculatorSettingsDrawerProps> = ({
    isDrawerOpen,
    onCloseDrawer,
    expandedSection,
}) => {
    const { t } = useTranslation();

    return (
        <SettingsDrawer isDrawerOpen={isDrawerOpen} onCloseDrawer={onCloseDrawer} title={t('liquidityCalculatorSettings.title')}>
            <Suspense fallback={<ZfLoadingSpinner />}>
                <LiquidityCalculatorDateRangeSelect />
                <LiquidityCashWithJbSettings expandedKey={expandedSection} />
                <LiquidityCashWithOtherBanksSettings expandedKey={expandedSection} />
                <LiquidityRecurringCashflowSettings expandedKey={expandedSection} />
                <LiquidityOneOffCashflowSettings expandedKey={expandedSection} />
            </Suspense>
        </SettingsDrawer>
    );
};
